let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1MsjM")).then(() => parcelRequire('3yDxt'));